import NoSleep from 'nosleep.js';


const noSleep = new NoSleep();
const ctxs = [];


export const enable = (ctx) => {
  if (!ctx) {
    throw new Error('Context "ctx" missing.');
  }

  if (!ctxs.includes(ctx)) {
    ctxs.push(ctx);
  }

  if (ctxs.length && !noSleep.isEnabled) {
    noSleep.enable();
  }
};


export const disable = (ctx) => {
  if (!ctx) {
    throw new Error('Context "ctx" missing.');
  }

  const index = ctxs.indexOf(ctx);
  if (index !== -1) {
    ctxs.splice(index, 1);
  }

  if (!ctxs.length && noSleep.isEnabled) {
    noSleep.disable();
  }
};
